/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SetUserActivePayloadModel model module.
 * @module model/SetUserActivePayloadModel
 * @version v1.0.0
 */
class SetUserActivePayloadModel {
    /**
     * Constructs a new <code>SetUserActivePayloadModel</code>.
     * @alias module:model/SetUserActivePayloadModel
     * @param active {Boolean} active status (required)
     * @param userId {String} user id (required)
     */
    constructor(active, userId) { 
        
        SetUserActivePayloadModel.initialize(this, active, userId);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, active, userId) { 
        obj['active'] = active;
        obj['userId'] = userId;
    }

    /**
     * Constructs a <code>SetUserActivePayloadModel</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SetUserActivePayloadModel} obj Optional instance to populate.
     * @return {module:model/SetUserActivePayloadModel} The populated <code>SetUserActivePayloadModel</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SetUserActivePayloadModel();

            if (data.hasOwnProperty('active')) {
                obj['active'] = ApiClient.convertToType(data['active'], 'Boolean');
            }
            if (data.hasOwnProperty('userId')) {
                obj['userId'] = ApiClient.convertToType(data['userId'], 'String');
            }
        }
        return obj;
    }


}

/**
 * active status (required)
 * @member {Boolean} active
 */
SetUserActivePayloadModel.prototype['active'] = undefined;

/**
 * user id (required)
 * @member {String} userId
 */
SetUserActivePayloadModel.prototype['userId'] = undefined;






export default SetUserActivePayloadModel;

